import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { sendPasswordRecoveryEmail } from "../../actions/userActions";
import Form from "./Form";
import { Grid, TextField } from "@material-ui/core";

class ForgotPasswordForm extends Component {
  state = {
    email: "",
  };

  sendPasswordRecoveryEmail = (e) => {
    e.preventDefault();
    this.props.sendPasswordRecoveryEmail(this.state);
  };

  handleChange = (e) => this.setState({ [e.target.name]: e.target.value });

  render() {
    return (
      <Form
        onSubmit={this.sendPasswordRecoveryEmail}
        submitText="Wijzigen"
        isFetching={this.props.isFetching}
        successMessage={this.props.successMessage}
        errorMessage={this.props.errorMessage}
      >
        <Grid container spacing={3}>
          <Grid item xs={12} sm={12}>
            <TextField
              id="email"
              name="email"
              label="Email *"
              value={this.state.email}
              onChange={this.handleChange}
              fullWidth
            />
          </Grid>
        </Grid>
      </Form>
    );
  }
}

ForgotPasswordForm.propTypes = {
  sendPasswordRecoveryEmail: PropTypes.func.isRequired,
  successMessage: PropTypes.string,
  errorMessage: PropTypes.arrayOf(PropTypes.string),
  isFetching: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  successMessage: state.user.sendPasswordRecoveryEmail.successMessage,
  errorMessage: state.user.sendPasswordRecoveryEmail.errorMessage,
  isFetching: state.user.sendPasswordRecoveryEmail.isFetching,
});

export default connect(mapStateToProps, { sendPasswordRecoveryEmail })(
  ForgotPasswordForm,
);



// WEBPACK FOOTER //
// ./src/components/forms/ForgotPasswordForm.js